<template>
  <div class="address-validate data-validate">
    <div class="validate-top">
      <div class="top-left">
        <span class="title">{{$t('User.addressVerifi')}}</span>
        <span
          :style="tagStyle"
          class="tag-box-address-validate"
        >{{tagText}}</span>
      </div>
      <div class="edit-btn">
        <i
          @click="editHandle"
          v-if="editFlag"
          class="iconfont icon-edit-21 pointer"></i>
      </div>
    </div>
    <el-row>
      <el-col
        :sm="12"
        :xs="24"
        class="left-box"
      >
        <div class="data-line">
          <span class="text-box">{{$t('Place_of_residence_region')}}: </span>
          <span class="data-box">{{parseCountry(allData.nationality)}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('Train.lecturesAddr')}}: </span>
          <span class="data-box">{{allData.homeProvince}}{{allData.homeCity}}{{allData.homeStreet}}{{allData.homeAddress}}</span>
        </div>
<!--        <div class="data-line">
          <span class="text-box">{{$t('proof_of_address')}}: </span>
          <span class="data-box file-down pointer">
            <a :href="this.allData.addressImgUrl" :download="this.subsctringFileName(this.allData.addressImgUrl)" target="_blank">{{$t('Annex_1')}}</a>
          </span>
        </div>-->
      </el-col>
<!--      <el-col
        :sm="12"
        :xs="24"
        class="right-col"
      >
        <div class="data-line">
          <div class="text-box">{{$t('proof_of_address')}}</div>
          <el-image
            class="id-img-el"
            :src="allData.addressImgUrl"
            alt=""
            :preview-src-list="[allData.addressImgUrl]"
          >
          </el-image>
        </div>
      </el-col>-->
    </el-row>
    <address-edit-dialog
      :dialog-show="dialogShow"
      @close="closeHandel"
      :all-data="allData"
      :parse-country="parseCountry(allData.nationality)"
      @ajax-success="editSuccess"
    ></address-edit-dialog>
  </div>
</template>

<script>
import { getDictListByType } from '@/api/home.js';
import { colorRgba,subsctringFileName } from "@/utils";
import addressEditDialog from "@/components/myFiles/personalInfo/addressEditDialog";
export default {
  name: "addressValidate",
  components:{
    addressEditDialog,
  },
  props: {
    allData: {
      type: Object,
      default(){
        return {
          identifyStatus: '',
          idType: '',
        }
      },
    },
  },
  data() {
    return {
      yellowColor: '#F29132',
      greenColor: '#41B883',
      redColor: '#D85E5F',
      countryList:[],
      dialogShow: false, // 调试 todo
    }
  },
  computed: {
    tagText() {
      //  1:待审核 2:审核不通过 3:审核通过
      let text = '';
      if(this.allData.addressStatus == 2){
        text = this.$t('personInfoAuthFail');
      }
      if(this.allData.addressStatus == 3){
        text = this.$t('User.authPass');
      }
      if(this.allData.addressStatus == 1){
        text = this.$t('User.authing');
      }
      return text;
    },

    editFlag(){
      if(this.allData.addressStatus == 2){
        return true;
      }else {
        return false;
      }
    },
    tagStyle(){
      if(this.allData.addressStatus == 2){
        return {
          backgroundColor: colorRgba(this.redColor,.1),
          color: this.redColor,
        }
      }else if(this.allData.addressStatus == 3){
        return {
          backgroundColor: colorRgba(this.greenColor,.1),
          color: this.greenColor,
        }
      }else if(this.allData.addressStatus == 1){
        return {
          backgroundColor: colorRgba(this.yellowColor,.1),
          color: this.yellowColor,
        };
      }
    },
  },
  created() {
    this.getDictListByType('countryList')
  },
  methods: {
    subsctringFileName,
    editHandle(){
      this.dialogShow = true;
    },
    getDictListByType(type){
      getDictListByType({
        type : type
      }).then((res) => {
        if(res.data[0].type == 'countryList') {
          this.countryList = res.data
        }
      })
    },
    // 国籍
    parseCountry(value){
      for(var i=0;i<this.countryList.length;i++){
        if(this.countryList[i].value ==value) {
          return this.countryList[i].label
        }
      }
    },
    closeHandel(){
      this.dialogShow = false;
    },
    editSuccess(){
      this.dialogShow = false;
      this.$emit('ajax-success');
    }
  },
}
</script>

<style lang="scss" scoped>
.address-validate {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
  .validate-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .top-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .tag-box-address-validate {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 15px;
    margin-left: 10px;
  }
  .left-box {
    .data-line {
      margin-bottom: 10px;
      .text-box {
        text-align: right;
        color: #A29FAE;
        font-size: 14px;
      }
      .data-box {
        text-align: left;
        color: #5E5873;
        font-size: 14px;
      }
    }
  }
  .right-col {
    .data-line {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .text-box {
      margin-right: 15px;
      color: #A29FAE;
    }
    .id-img-el {
      width: 120px;
      height: 70px;
      margin-right: 10px;
    }
  }
  .file-down {
    display: inline-block;
    padding: 0 20px;
  }
}
</style>
